import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const ELLIPSES = '…';
const SHOW_LESS_TEXT = 'Collapse';
const SHOW_MORE_TEXT = 'Read More';

const ReadMore = props => {
  const {
    numberOfLines = 5,
    readMoreCharacterLimit = 100,
    showLessButton = true,
    text,
    onOpenHandler,
    onCloseHandler,
    condition = false,
    styles,
  } = props;

  const [showAll, setShowAll] = useState(condition);

  const toggleReadMore = () => {
    const condition = !showAll;
    setShowAll(condition);
    if (condition && onOpenHandler && typeof onOpenHandler === 'function') {
      onOpenHandler();
    }
    if (!condition && onCloseHandler && typeof onCloseHandler === 'function') {
      onCloseHandler();
    }
  };

  const _getReadMoreParts = ({
    text,
    numberOfLines,
    readMoreCharacterLimit,
  }) => {
    let teaserText;
    let remainingText;
    let remainingWordsArray = [];

    if (text) {
      const teaserWordsArray = text.split(' ');

      while (teaserWordsArray.join(' ').length > readMoreCharacterLimit) {
        remainingWordsArray.unshift(teaserWordsArray.pop());
      }

      teaserText = teaserWordsArray.join(' ');

      if (remainingWordsArray.length > 0) {
        remainingText = remainingWordsArray.join(' ');
      }
    }

    return {
      teaserText,
      remainingText,
    };
  };

  const getText = ({
    showAll,
    text,
    readMoreCharacterLimit,
    numberOfLines,
  }) => {
    let { teaserText, remainingText } = _getReadMoreParts({
      text,
      numberOfLines,
      readMoreCharacterLimit,
    });

    if (!showAll && text.length > readMoreCharacterLimit) {
      return (
        <p className="read-more__container">
          {teaserText.replace(/\s*$/, '')}
          <span className="read-more__text--remaining read-more__text--hide">
            {remainingText}
          </span>
          {ELLIPSES}
        </p>
      );
    }

    return (
      <p className="read-more__container">
        {teaserText}
        <span className="read-more__text--remaining read-more__text--show">
          {' '}
          {remainingText}
        </span>
      </p>
    );
  };

  const getActionButton = ({ showAll, showLessButton }) => {
    if (showAll && !showLessButton) {
      return;
    }

    if (text.length < readMoreCharacterLimit) {
      return;
    }

    let buttonText = showAll ? SHOW_LESS_TEXT : SHOW_MORE_TEXT;

    return (
      <button onClick={toggleReadMore} className="read-more__button">
        {buttonText}
      </button>
    );
  };

  let textToDisplay = getText({
    showAll,
    text,
    readMoreCharacterLimit,
    numberOfLines,
  });
  let actionButton = getActionButton({ showAll, showLessButton });

  return (
    <div className="read-more" style={styles}>
      {textToDisplay} {actionButton}
    </div>
  );
};

ReadMore.propTypes = {
  numberOfLines: PropTypes.number,
  lineHeight: PropTypes.number,
  readMoreCharacterLimit: PropTypes.number,
  showLessButton: PropTypes.bool,
  condition: PropTypes.bool,
  text: PropTypes.string,
  onOpenHandler: PropTypes.func,
  onCloseHandler: PropTypes.func,
  styles: PropTypes.object,
};

export default ReadMore;
